import { NgModule } from '@angular/core';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { GalleriaModule } from 'primeng/galleria';
import { ButtonModule } from 'primeng/button';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { NavbarFabComponent } from './navbar/navbar-fab.component';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PreviewViewerComponent } from "ng/src/app/core/preview-viewer/preview-viewer.component";
import { FilesModule } from "ng/src/app/files/files.module";
import { VideoTipsViewerComponent } from "ng/src/app/core/changelog-viewer/video-tips-viewer.component";
import { SharedModule } from "ng/src/app/shared/shared.module";
import { DividerModule } from "primeng/divider";
import { RippleModule } from "primeng/ripple";
import { HelpLinkDirective } from "ng/src/app/core/help-link/help-link.directive";
import { HelpDialogComponent } from "ng/src/app/core/help-dialog/help-dialog.component";
import { CarouselModule } from "primeng/carousel";
import { DialogModule } from "primeng/dialog";

@NgModule({
	declarations: [
		ImageViewerComponent,
		NavbarFabComponent,
		ImageViewerComponent,
		PreviewViewerComponent,
		VideoTipsViewerComponent,
		HelpLinkDirective,
		HelpDialogComponent
    ],
	imports: [
		GalleriaModule,
		ButtonModule,
		NgxImageZoomModule,
		TieredMenuModule,
		OverlayPanelModule,
		NgxImageZoomModule,
		FilesModule,
		SharedModule,
		DividerModule,
		RippleModule,
		CarouselModule,
		DialogModule
	],
	exports: [
		VideoTipsViewerComponent,
		HelpLinkDirective,
		HelpDialogComponent
	]
})
export class CoreModule { }